import React, { useState } from 'react';
import { Row, Col, Modal } from 'react-bootstrap';
import './VehicleImageGallery.css';

const VehicleImageGallery = ({ images }) => {
    const [selectedImage, setSelectedImage] = useState(images && images.length > 0 ? images[0] : null);
    const [showModal, setShowModal] = useState(false);
    const [modalImageIndex, setModalImageIndex] = useState(0);

    // Varsayılan resim kullan eğer hiç resim yoksa
    // placeholder yerine gerçek default.png kullanılıyor
    const defaultImage = '/uploads/vehicles/default.png';
    const validImages = images && images.length > 0 ? images : [defaultImage];

    // Ana resme tıklama
    const handleMainImageClick = () => {
        setModalImageIndex(validImages.indexOf(selectedImage));
        setShowModal(true);
    };

    // Küçük resme tıklama
    // Küçük resme tıklama
    const handleThumbnailClick = (image) => {
        setSelectedImage(image);
    };

    // Modal'da sonraki resim
    const nextImage = () => {
        const newIndex = (modalImageIndex + 1) % validImages.length;
        setModalImageIndex(newIndex);
    };

    // Modal'da önceki resim
    const prevImage = () => {
        const newIndex = (modalImageIndex - 1 + validImages.length) % validImages.length;
        setModalImageIndex(newIndex);
    };

    return (
        <>
            <div className="vehicle-gallery">
                <div className="main-image-container">
                    <img
                        src={selectedImage || defaultImage}
                        alt="Araç Görseli"
                        className="main-image"
                        onClick={handleMainImageClick}
                    />
                    <div className="image-count">{validImages.length} Fotoğraf</div>
                </div>

                {validImages.length > 1 && (
                    <Row className="thumbnails-row mt-2">
                        {validImages.map((image, index) => (
                            <Col key={index} xs={3} md={2} className="mb-2">
                                <img
                                    src={image}
                                    alt={`Araç Görseli ${index + 1}`}
                                    className={`thumbnail-image ${selectedImage === image ? 'active' : ''}`}
                                    onClick={() => handleThumbnailClick(image)}
                                />
                            </Col>
                        ))}
                    </Row>
                )}
            </div>

            {/* Tam ekran görsel galerisi */}
            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                size="xl"
                centered
                className="gallery-modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Araç Galerisi</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="fullscreen-image-container">
                        <button className="nav-button prev" onClick={prevImage}>‹</button>
                        <img
                            src={validImages[modalImageIndex]}
                            alt={`Araç Görseli ${modalImageIndex + 1}`}
                            className="fullscreen-image"
                        />
                        <button className="nav-button next" onClick={nextImage}>›</button>
                    </div>
                    <div className="image-counter">
                        {modalImageIndex + 1} / {validImages.length}
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default VehicleImageGallery;